import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-rtk-base-analyzer-help-dialog',
  templateUrl: './rtk-base-analyzer-help-dialog.component.html',
  styleUrls: ['./rtk-base-analyzer-help-dialog.component.scss']
})
export class RtkBaseAnalyzerHelpDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<RtkBaseAnalyzerHelpDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}


